import { testIdAttr } from '@src/components/testId';
import './NotificationBadge.css';

export function NotificationBadge({
  count,
  className = '',
  testId,
}: {
  count: number;
  className?: string;
  testId?: string;
}) {
  if (count <= 0) return null;
  return (
    <span className={`notification-badge ${className}`} {...testIdAttr(testId)}>
      {count > 99 ? '99+' : count}
    </span>
  );
}

export function NotificationDot({ className = '', testId }: { className?: string; testId?: string }) {
  return <span className={`notification-badge notification-badge--dot ${className}`} aria-hidden="true" {...testIdAttr(testId)} />;
}
